module.exports = __webpack_public_path__ + "static/img/beer-bg.50fdccd7.png";